<template>
    <div>
        <div class="grid">
            <div class="col-12 xl:col-4">
                <div class="card" style="background-color: #D5ECFC;height:100%">

                    <b>
                        <center>Visits</center>
                    </b>
                    <hr>
                    <center>
                        <b>
                            <VueGauge title="Visits" value="35000" rangeLabel="100000" />
                        </b>
                    </center>
                    <b>
                        <center style="margin-top:10px">Today's Visits : 35000</center>
                    </b>

                </div>
            </div>
            <div class="col-12 xl:col-4">
                <div class="card" style="background-color: #D5ECFC;height:100%">

                    <b>
                        <center>Vehicles</center>
                    </b>
                    <hr>
                    <center>
                        <b>
                            <VueGauge title="Vehicles" value="28000" rangeLabel="40000" />
                        </b>
                    </center>
                    <b>
                        <center style="margin-top:10px">Today's Active Vehicle : 28000</center>
                    </b>

                </div>
            </div>
            <div class="col-12 xl:col-4">
                <div class="card" style="background-color: #D5ECFC; height:100%">

                    <b>
                        <center>BreakDown Vehicles</center>
                    </b>
                    <hr>
                    <center>
                        <Chart type="pie" :data="chartData1" :options="chartOptions1" class="w-full md:w-11rem" />
                    </center><br>
                    <b>
                        <center style="margin-top:10px">Total Breakdown vehicles : 2365</center>
                    </b>

                </div>
            </div>
            <!-- <div class="col-12 xl:col-3">
                            <div class="card" style="background-color: #D5ECFC; height:100%">
                                
                                <b><center>Vehicles</center></b>
                                <hr>
                                <center>
                                    <Chart type="pie" :data="chartData3" :options="chartOptions3" class="w-full md:w-11rem" />
                                </center><br>
                                <b><center style="margin-top:10px">Total vehicles : 40000</center></b>

                            </div>
                        </div> -->
        </div>
        <!-- ======================================================== -->
        <div class="grid">
            <div :class="{ 'col-12': true, 'xl:col-6': !isZoomed, 'xl:col-12': isZoomed }" v-if="!isZoomed1">

                <div class="card" style="background-color: #D5ECFC;" @click="toggleZoom">
                    <center>
                        <b>Last 30 Days Visits</b>
                        <hr>
                        <Chart type="bar" :data="chartData" :options="chartOptions" class="h-20rem" />
                        <b>Visited Home/Total Homes</b>
                    </center>
                </div>

            </div>
            <div :class="{ 'col-12': true, 'xl:col-6': !isZoomed1, 'xl:col-12': isZoomed1 }" v-if="!isZoomed">
                <div class="card" style="background-color: #D5ECFC;" @click="toggleZoom1">
                    <center>
                        <b>Last 30 Days Active Vehicles</b>
                        <hr>
                        <Chart type="bar" :data="chartData2" :options="chartOptions2" class="h-20rem" />
                        <b>Vehicle with Ride/Total Vehicles</b>
                    </center>
                </div>
            </div>
        </div>
        <!-- ================================================================== -->
        <div class="grid">
            <div class="col-12 xl:col-4">
                <div class="card">
                    <DataTable ref="dt4" :value="Top_village" class="p-datatable-sm" :rows="10" responsiveLayout="scroll"
                        style="font-size: 12px" :paginator="true" dataKey="id" :rowHover="true" showGridlines>
                        <template #header>
                            <div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
                                <h5 class="m-0">Villages (top 10)</h5>
                            </div>
                        </template>
                        <Column field="top_village_name" header="Village Name" style="width:80%">
                            <template #body="{ data }">
                                <span>{{ data.village_name }}</span>
                            </template>
                        </Column>
                        <Column field="Visits" header="Visits(%)" style="width:20%;text-align: center;">
                            <template #body="{ data }">
                                <span>{{ data.Visits }}</span>
                            </template>
                        </Column>
                    </DataTable>
                </div>
            </div>
            <div class="col-12 xl:col-4">
                <div class="card">
                    <DataTable ref="dt4" :value="Top_cluster" class="p-datatable-sm" :rows="10" responsiveLayout="scroll"
                        style="font-size: 12px" :paginator="true" dataKey="id" :rowHover="true" showGridlines>
                        <template #header>
                            <div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
                                <h5 class="m-0">Clusters (top 10)</h5>
                            </div>
                        </template>
                        <Column field="cluster_name" header="Clusters Name" style="width:80%">
                            <template #body="{ data }">
                                <span>{{ data.cluster_name }}</span>
                            </template>
                        </Column>
                        <Column field="Visits" header="Visits(%)" style="width:20%;text-align: center;">
                            <template #body="{ data }">
                                <span>{{ data.Visits }}</span>
                            </template>
                        </Column>
                    </DataTable>
                </div>
            </div>
            <div class="col-12 xl:col-4">
                <div class="card">
                    <DataTable ref="dt4" :value="Top_districts" class="p-datatable-sm" :rows="10" responsiveLayout="scroll"
                        style="font-size: 12px" :paginator="true" dataKey="id" :rowHover="true" showGridlines>
                        <template #header>
                            <div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
                                <h5 class="m-0">Districts (top 10)</h5>
                            </div>
                        </template>
                        <Column field="districts_name" header="Districts Name" style="width:80%">
                            <template #body="{ data }">
                                <span>{{ data.districts_name }}</span>
                            </template>
                        </Column>
                        <Column field="Visits" header="Visits(%)" style="width:20%;text-align: center;">
                            <template #body="{ data }">
                                <span>{{ data.Visits }}</span>
                            </template>
                        </Column>
                    </DataTable>
                </div>
            </div>
        </div>
        <div class="grid">
            <div class="col-12 xl:col-4">
                <div class="card">
                    <DataTable ref="dt4" :value="Bottom_village" class="p-datatable-sm" :rows="10" responsiveLayout="scroll"
                        style="font-size: 12px" :paginator="true" dataKey="id" :rowHover="true" showGridlines>
                        <template #header>
                            <div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
                                <h5 class="m-0">Villages (Bottom 10)</h5>
                            </div>
                        </template>
                        <Column field="village_name" header="Village Name" style="width:80%">
                            <template #body="{ data }">
                                <span>{{ data.village_name }}</span>
                            </template>
                        </Column>
                        <Column field="Visits" header="Visits(%)" style="width:20%;text-align: center;">
                            <template #body="{ data }">
                                <span>{{ data.Visits }}</span>
                            </template>
                        </Column>
                    </DataTable>
                </div>
            </div>
            <div class="col-12 xl:col-4">
                <div class="card">
                    <DataTable ref="dt4" :value="Bottom_cluster" class="p-datatable-sm" :rows="10" responsiveLayout="scroll"
                        style="font-size: 12px" :paginator="true" dataKey="id" :rowHover="true" showGridlines>
                        <template #header>
                            <div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
                                <h5 class="m-0">Clusters (Bottom 10)</h5>
                            </div>
                        </template>
                        <Column field="cluster_name" header="Clusters Name" style="width:80%">
                            <template #body="{ data }">
                                <span>{{ data.cluster_name }}</span>
                            </template>
                        </Column>
                        <Column field="Visits" header="Visits(%)" style="width:20%;text-align: center;">
                            <template #body="{ data }">
                                <span>{{ data.Visits }}</span>
                            </template>
                        </Column>
                    </DataTable>
                </div>
            </div>
            <div class="col-12 xl:col-4">
                <div class="card">
                    <DataTable ref="dt4" :value="Bottom_districts" class="p-datatable-sm" :rows="10"
                        responsiveLayout="scroll" style="font-size: 12px" :paginator="true" dataKey="id" :rowHover="true"
                        showGridlines>
                        <template #header>
                            <div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
                                <h5 class="m-0">Districts (Bottom 10)</h5>
                            </div>
                        </template>
                        <Column field="districts_name" header="Districts Name" style="width:80%">
                            <template #body="{ data }">
                                <span>{{ data.districts_name }}</span>
                            </template>
                        </Column>
                        <Column field="Visits" header="Visits(%)" style="width:20%;text-align: center;">
                            <template #body="{ data }">
                                <span>{{ data.Visits }}</span>
                            </template>
                        </Column>
                    </DataTable>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import VueGauge from '../components/VueGauge'
export default {
    name: 'TravelSafeUiSolidWaste',

    data() {
        return {

            isZoomed: false,
            isZoomed1: false,

            chartData1: null,
            chartOptions1: {
                plugins: {
                    legend: {
                        display: false
                    },
                    tooltips: {
                        enabled: false
                    }
                }
            },

            chartData: null,
            chartOptions: null,
            chartData2: null,
            chartOptions2: null,

            //======================================
            Top_village: [
                { village_name: 'Palghar', Visits: 98 },
                { village_name: 'Thane', Visits: 97 },
                { village_name: 'Kalyan', Visits: 96 },
                { village_name: 'Bhiwandi', Visits: 96 },
                { village_name: 'Diva', Visits: 95 },
                { village_name: 'Vasai', Visits: 93 },
                { village_name: 'Andheri', Visits: 92 },
                { village_name: 'Dadar', Visits: 91 },
                { village_name: 'karjat', Visits: 90 },
                { village_name: 'kasara', Visits: 89 },

            ],
            Top_cluster: [
                { cluster_name: 'Cluster Name 1', Visits: 99 },
                { cluster_name: 'Cluster Name 2', Visits: 97 },
                { cluster_name: 'Cluster Name 3', Visits: 95 },
                { cluster_name: 'Cluster Name 4', Visits: 94 },
                { cluster_name: 'Cluster Name 5', Visits: 94 },
                { cluster_name: 'Cluster Name 6', Visits: 93 },
                { cluster_name: 'Cluster Name 7', Visits: 92 },
                { cluster_name: 'Cluster Name 8', Visits: 91 },
                { cluster_name: 'Cluster Name 9', Visits: 90 },
                { cluster_name: 'Cluster Name 10', Visits: 89 },

            ],
            Top_districts: [
                { districts_name: 'Amravati', Visits: 97 },
                { districts_name: 'Sangli', Visits: 96 },
                { districts_name: 'Satara', Visits: 96 },
                { districts_name: 'Solapur', Visits: 95 },
                { districts_name: 'Kolhapur', Visits: 95 },
                { districts_name: 'Pune', Visits: 94 },
                { districts_name: 'Akola', Visits: 93 },
                { districts_name: 'Buldhana', Visits: 92 },
                { districts_name: 'Yavatmal', Visits: 92 },
                { districts_name: 'Washim', Visits: 91 },

            ],
            Bottom_village: [
                { village_name: 'Panvel', Visits: 20 },
                { village_name: 'Swawood', Visits: 30 },
                { village_name: 'khandeshwar', Visits: 40 },
                { village_name: 'Mansarovar', Visits: 45 },
                { village_name: 'Nerul', Visits: 45 },
                { village_name: 'Sanpada', Visits: 47 },
                { village_name: 'Vashi', Visits: 48 },
                { village_name: 'Mankhurd', Visits: 49 },
                { village_name: 'Turbhe', Visits: 49 },
                { village_name: 'Ghansoli', Visits: 51 },

            ],
            Bottom_cluster: [
                { cluster_name: 'Cluster Name 1', Visits: 20 },
                { cluster_name: 'Cluster Name 2', Visits: 35 },
                { cluster_name: 'Cluster Name 3', Visits: 40 },
                { cluster_name: 'Cluster Name 4', Visits: 41 },
                { cluster_name: 'Cluster Name 5', Visits: 42 },
                { cluster_name: 'Cluster Name 6', Visits: 43 },
                { cluster_name: 'Cluster Name 7', Visits: 43 },
                { cluster_name: 'Cluster Name 8', Visits: 44 },
                { cluster_name: 'Cluster Name 9', Visits: 45 },
                { cluster_name: 'Cluster Name 10', Visits: 48 },

            ],
            Bottom_districts: [
                { districts_name: 'Beed', Visits: 20 },
                { districts_name: 'Jalna', Visits: 25 },
                { districts_name: 'Dharashiv', Visits: 28 },
                { districts_name: 'Nanded', Visits: 29 },
                { districts_name: 'Latur', Visits: 32 },
                { districts_name: 'Parbhani', Visits: 33 },
                { districts_name: 'Hingoli', Visits: 35 },
                { districts_name: 'Bhandara', Visits: 36 },
                { districts_name: 'Chandrapur', Visits: 36 },
                { districts_name: 'Gadchiroli ', Visits: 38 },

            ],

        };
    },
    components: { VueGauge },

    mounted() {
        this.chartData = this.setChartData();
        this.chartOptions = this.setChartOptions();
        this.chartData1 = this.setChartData1();
        this.chartData2 = this.setChartData2();
        this.chartOptions2 = this.setChartOptions2();
        //this.chartData3 = this.setChartData3();
    },

    methods: {
        toggleZoom() {
            this.isZoomed = !this.isZoomed;
        },
        toggleZoom1() {
            this.isZoomed1 = !this.isZoomed1;
        },
        setChartOptions2() {


            // return {
            //     maintainAspectRatio: false,
            //     aspectRatio: 0.8,
            //     plugins: {
            //         tooltips: {
            //             mode: 'index',
            //             intersect: false
            //         },
            //         legend: {
            //             labels: {
            //                 color: '#908fa8'
            //             }
            //         }
            //     },
            //     scales: {
            //         x: {
            //             stacked: true,
            //             ticks: {
            //                 color: '#908fa8'
            //             },
            //             grid: {
            //                 color: '#908fa8'
            //             }
            //         },
            //         y: {
            //             stacked: true,
            //             ticks: {
            //                 color: '#908fa8'
            //             },
            //             grid: {
            //                 color: '#908fa8'
            //             }
            //         }
            //     }
            // };
            return {
                maintainAspectRatio: false,
                aspectRatio: 0.8,
                plugins: {
                    legend: {
                        labels: {
                            fontColor: '#908fa8'
                        }
                    }
                },
                scales: {
                    x: {
                        ticks: {
                            color: '#908fa8',
                            font: {
                                weight: 500
                            }
                        },
                        grid: {
                            display: false,
                            drawBorder: false
                        }
                    },
                    y: {
                        ticks: {
                            color: '#908fa8'
                        },
                        grid: {
                            color: '#908fa8',
                            drawBorder: false
                        }
                    }
                }
            };
        },
        setChartData2() {


            return {
                //labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
                labels: ["1-6-2023", "2-6-2023", "3-6-2023", "4-6-2023", "5-6-2023", "6-6-2023", "7-6-2023", "8-6-2023", "9-6-2023", "10-6-2023", "11-6-2023", "12-6-2023", "13-6-2023", "14-6-2023", "15-6-2023", "16-6-2023", "17-6-2023", "18-6-2023", "19-6-2023", "20-6-2023", "21-6-2023", "22-6-2023", "23-6-2023", "24-6-2023", "25-6-2023", "26-6-2023", "27-6-2023", "28-6-2023", "29-6-2023", "30-6-2023"],

                datasets: [
                    {
                        type: 'bar',
                        label: 'Vehicle With Ride',
                        backgroundColor: '#173EA3',
                        data: [20101, 22201, 24521, 26121, 21254, 22654, 25212, 20101, 22201, 24521, 26121, 21254, 22654, 25212, 20101, 22201, 24521, 26121, 21254, 22654, 25212, 20101, 22201, 24521, 26121, 21254, 22654, 25212, 21254, 25487]
                    },
                    {
                        type: 'bar',
                        label: 'Total Vehicles',
                        backgroundColor: '#FF5454',
                        data: [40000, 40000, 40000, 40000, 40000, 40000, 40000, 40000, 40000, 40000, 40000, 40000, 40000, 40000, 40000, 40000, 40000, 40000, 40000, 40000, 40000, 40000, 40000, 40000, 40000, 40000, 40000, 40000, 40000, 40000]
                    },

                ]
            };
        },
        setChartData1() {


            return {
                labels: ['Flat or faulty battery', 'Lost keys', 'Damaged tyres and wheels', 'Overheating', 'Fuel problems'],
                datasets: [
                    {
                        data: [540, 325, 702, 220, 84],
                        backgroundColor: ['#6366F1', '#EADA41', '#3DCC5B', 'black', '#FF5454'],
                        hoverBackgroundColor: ['#FF5454', 'pink', '#F77275', '#EADA41', '#3DCC5B']
                    }
                ]
            };
        },
        setChartData() {


            return {
                //labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
                labels: ["1-6-2023", "2-6-2023", "3-6-2023", "4-6-2023", "5-6-2023", "6-6-2023", "7-6-2023", "8-6-2023", "9-6-2023", "10-6-2023", "11-6-2023", "12-6-2023", "13-6-2023", "14-6-2023", "15-6-2023", "16-6-2023", "17-6-2023", "18-6-2023", "19-6-2023", "20-6-2023", "21-6-2023", "22-6-2023", "23-6-2023", "24-6-2023", "25-6-2023", "26-6-2023", "27-6-2023", "28-6-2023", "29-6-2023", "30-6-2023"],

                datasets: [
                    {
                        type: 'bar',
                        label: 'Visited Home',
                        backgroundColor: '#173EA3',
                        data: [75000, 74058, 76889, 75894, 78215, 77854, 35000, 75000, 74058, 76889, 75894, 78215, 77854, 35000, 75000, 74058, 76889, 75894, 78215, 77854, 35000, 75000, 74058, 76889, 75894, 78215, 77854, 35000, 78124, 76982]

                    },
                    {
                        type: 'bar',
                        label: 'Total Homes',
                        backgroundColor: '#FF5454',
                        data: [100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000]

                    },

                ]
            };
        },
        setChartOptions() {

            //stackdata
            // return {
            //     maintainAspectRatio: false,
            //     aspectRatio: 0.8,
            //     plugins: {
            //         tooltips: {
            //             mode: 'index',
            //             intersect: false
            //         },
            //         legend: {
            //             labels: {
            //                 color: '#908fa8'
            //             }
            //         }
            //     },
            //     scales: {
            //         x: {
            //             stacked: true,
            //             ticks: {
            //                 color: '#908fa8'
            //             },
            //             grid: {
            //                 color: '#908fa8'
            //             }
            //         },
            //         y: {
            //             stacked: true,
            //             ticks: {
            //                 color: '#908fa8'
            //             },
            //             grid: {
            //                 color: '#908fa8'
            //             }
            //         }
            //     }
            // };

            return {
                maintainAspectRatio: false,
                aspectRatio: 0.8,
                plugins: {
                    legend: {
                        labels: {
                            fontColor: '#908fa8'
                        }
                    }
                },
                scales: {
                    x: {
                        ticks: {
                            color: '#908fa8',
                            font: {
                                weight: 500
                            }
                        },
                        grid: {
                            display: false,
                            drawBorder: false
                        }
                    },
                    y: {
                        ticks: {
                            color: '#908fa8'
                        },
                        grid: {
                            color: '#908fa8',
                            drawBorder: false
                        }
                    }
                }
            };
        },

    },
};
</script>

<style lang="scss" scoped></style>